/**
 * SORT INDICATORS ENTRY POINT
 *
 * The SORT INDICATORS component can be used inline to show sorting orders.
 * The active direction will change according to the sort order.
 *
 * @version 0.1
 */

import React from 'react';

function SortIndicator({direction}) {

    let triangleUpState = ' inactive',
        triangleDownState = ' inactive';

    switch (direction) {
        case 'asc':
            triangleUpState = ' active';
            triangleDownState = ' visibility-hidden';
            break;
        case 'desc':
            triangleUpState = ' visibility-hidden';
            triangleDownState = ' active';
            break;
        default:
            triangleUpState = ' inactive';
            triangleDownState = ' inactive';
    }

    return (
        <div className="sort-indicators">
             <div className={'la-TriangleUp' + triangleUpState} />
             <div className={'la-TriangleDown' + triangleDownState} />
        </div>
    );

}

export default SortIndicator;


// WEBPACK FOOTER //
// ./src/scripts/reusable/SortIndicators/SortIndicators.index.jsx